import * as React from 'react';
import { Container } from '@grandvisionhq/elements';
import { usePlpDatalayerEvents } from '../utils/DataLayer/hooks/use-plp-datalayer-events.js';
import ProductListingPage from './ProductListingPage/ProductListingPage.js';
import ProductListingSkeleton from './ProductListingSkeleton/ProductListingSkeleton.js';

const ProductListing = ({ products , showMoreButton , promotionBig , promotionSmall , reimbursableLogos , forwardedQueryParams ,  })=>{
    const { trackMonetateImpressions  } = usePlpDatalayerEvents();
    const monetateProducts = products.pages.flat().filter((product)=>product !== null
    );
    React.useEffect(()=>{
        trackMonetateImpressions(monetateProducts);
    // Disabling exhaustive deps cause we want to run it only when updating the products length
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        monetateProducts.length
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-listing"
    }, /*#__PURE__*/ React.createElement(Container, {
        className: "product-listing__container"
    }, products.pages.map((page, i)=>{
        const pageNr = i + 1;
        return page === null ? /*#__PURE__*/ React.createElement(ProductListingSkeleton, {
            key: `product-listing-skeleton-${pageNr}`,
            pageSize: products.size
        }) : /*#__PURE__*/ React.createElement(ProductListingPage, {
            key: `product-listing-page-${pageNr}`,
            products: page,
            pageSize: products.size,
            pageNumber: pageNr,
            promotionBig: promotionBig,
            promotionSmall: promotionSmall,
            reimbursableLogos: reimbursableLogos,
            forwardedQueryParams: forwardedQueryParams
        });
    }), showMoreButton && /*#__PURE__*/ React.createElement("div", {
        className: "product-listing__show-more"
    }, showMoreButton)));
};

export { ProductListing, ProductListing as default };
//# sourceMappingURL=ProductListing.js.map
